import axios from 'axios';
import { getBackendURL } from '../Utils/ServerURL';
const sRUControllerEndpoint = 'LotCreationL4';


export class UsedRentalsOptionalsAPI {

  getRUOptionalsByL2Id(L2Id) {
    return axios.get(getBackendURL() + sRUControllerEndpoint + '/GetOptionalsByRUL2Id?ruL2Id=' + L2Id);
  }

  updateRUOptionalsByL2Id(optionalsDTO) {
    return axios.put(getBackendURL() + sRUControllerEndpoint + '/UpdateBulkOptionalsLotL4RU', optionalsDTO);
  }

  getRUOptionalsByL4Id(L4Id) {
    return axios.get(getBackendURL() + sRUControllerEndpoint + '/GetOptionalsByRUL4Id?ruL4Id=' + L4Id);
  }

  updateRUOptionalsByL4Id(optionalsDTO) {
    return axios.put(getBackendURL() + sRUControllerEndpoint + '/UpdateCarOptionalsLotL4RU', optionalsDTO);
  }

}

export default UsedRentalsOptionalsAPI


// WEBPACK FOOTER //
// ./src/API/UsedRentalsOptionalsAPI.js